import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";

import { ADPResourceService as ResourceService } from "digital-core";

@Component({
  selector: "gsp-question-card",
  templateUrl: "./question-card.html",
  styleUrls: ["./question-card.css"]
})
export class QuestionCardComponent implements OnInit {
  @Input()
  questionText: string;
  @Output()
  preneedStepperAnswer = new EventEmitter();

  CardTitle: any;
  Answer = new UntypedFormControl();
  Answers: string[];

  constructor(public resourceService: ResourceService) {}

  ngOnInit() {
    this.Answers = [
      this.resourceService.getViewLabel("Global_Text_Yes"),
      this.resourceService.getViewLabel("Global_Text_No")
    ];
    // this.CardTitle = this.resourceService.getViewLabel(
    //   "QuestionCard_Text_Title"
    // );
    this.CardTitle = this.questionText;
  }

  RadioChange(event: any) {
    if (event.value === this.resourceService.getViewLabel("Global_Text_Yes")) {
      this.preneedStepperAnswer.emit(true);
    } else {
      this.preneedStepperAnswer.emit(false);
    }
  }
}
